import React from 'react';
import { ShippingLineItem } from '../../DeShippingTableWrapper';

// Utility function to parse location strings
const parseLocationString = (locationStr: string) => {
  const dashIndex = locationStr.indexOf(' - ');
  
  if (dashIndex === -1) {
    return { storeCode: locationStr.trim(), storeName: locationStr.trim() };
  }
  
  const storeCode = locationStr.substring(0, dashIndex).trim();
  const storeName = locationStr.substring(dashIndex + 3).trim();
  
  return { storeCode, storeName };
};

// Line item fulfillment location template function
export const LineItemFulfillmentLocationTemplate = (rowData: ShippingLineItem) => {
  const fulfillmentLocation = rowData.fulfillment_location;
  
  // Check if fulfillmentLocation is null, undefined, or empty
  if (!fulfillmentLocation || fulfillmentLocation.trim() === '') {
    return <span className="text-warning">Not assigned</span>;
  }
  
  // Parse the location string
  const { storeCode, storeName } = parseLocationString(fulfillmentLocation);
  
  return (
    <div className="fulfillment-location-info">
      <div className="fw-semibold">{storeName}</div>
      <div className="small text-muted">{storeCode}</div>
    </div>
  );
};